import {memo, useContext, useEffect, useRef, useState} from 'react';
import {Handle, Position} from 'reactflow';
import {WorkflowCanvasContext} from "../../contexts/WorkflowCanvasContextProvider";
import BlockChildNode from "./BlockChildNode";

import "./main_workflow_node.scss";
import Toolbar from "./Toolbar";

const StartNode = ({id, data}) => {

    const workflowContext = useContext(WorkflowCanvasContext);

    const contextMenuRef = useRef(null);
    const [isInput, setIsInput] = useState(false);
    const [blockTitle, setBlockTitle] = useState(data.label);

    const [showToolbar, setShowToolbar] = useState(false);

    useEffect(() => {
        // Add event listener when the component is mounted
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            // Clean up event listener when the component is unmounted
            document.removeEventListener("click", handleClickOutside);
            document.addEventListener("mousedown", handleClickOutside);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClickOutside = (event) => {
        if (contextMenuRef.current && !contextMenuRef.current.contains(event.target)) {
            setShowToolbar(false);
            workflowContext.setDeletableChildId(null)
        }
    };

    const handleToolBarVisible = e => {
        e.preventDefault();
        setShowToolbar(true);
    }

    const handleOpenDrawer = () => {
        if (data?.openNodeDrawer) {
            data.openNodeDrawer(id);
        }
    };

    const invalid = workflowContext.invalidStates?.includes(String(id));

    return (
        <div style={{position: "relative"}}>
            <div
                className={`flex items-center gap-2 rounded-full bg-primary px-5 py-2 text-sm font-semibold text-white
                    shadow-sm transition-shadow duration-200 hover:shadow-md
                      ${invalid ? 'ring-2 ring-red-500 ring-offset-2' : ''}`}
                onClick={() => setShowToolbar(false)}
                onContextMenu={handleToolBarVisible}
                onDoubleClick={handleOpenDrawer}
                // style={{backgroundColor: "#DDE4EA", borderRadius: "4px"}}

            >
                <span className="h-1.5 w-1.5 rounded-full bg-brand-lime" aria-hidden="true" />
                <p className="m-0">Start</p>
                <div className="">
                    <Handle
                        type="source"
                        position={Position.Right}
                        className="absolute right-[15px] flex h-[14px] w-[14px] items-center justify-center border-2 border-white bg-primary shadow-sm"
                        id='start'
                    />
                </div>


            </div>
        </div>
    );
};

export default memo(StartNode);
